import {textSizes} from '@stencil/build-theme';
import styled from 'styled-components';

export const RoomTypesBtn = styled.div`
  ${textSizes.MediumW3}
  width: 175px;
  padding: ${props => props.theme.spacing.custom(8)} ${props => props.theme.spacing.custom(24)};
  color: ${props => props.theme.colors.goWhite.base};
  position: relative;
  border-radius: ${props => props.theme.misc.borderRadius.custom(40)};
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.25);
  background-image: linear-gradient(to right, #1149f3 0%, #00c3ff 100%);
  cursor: pointer;
  &:before {
    border: solid #fff;
    border-width: 0 0.2rem 0.2rem 0;
    display: inline-block;
    padding: 0.4rem;
    transform: ${props => (props.active ? 'rotate(225deg)' : 'rotate(45deg)')};
    position: absolute;
    right: 1.8rem;
    top: ${props => (props.active ? '1.6rem' : '1.2rem')};
    content: '';
    transition: all 0.5s ease;
  }
`;

export const RoomTypeDropdown = styled.ul(
  props => `
    max-height:300px;
    overflow-y:scroll;
    overflow-x: hidden;
    position: relative;
    width: 315px;
    position: absolute;
    top: 4.5rem;
    left: 0;
    background: ${props.theme.colors.goWhite.base};
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.12);
    border-radius: ${props.theme.misc.borderRadius.xlarge};
    z-index: 3;
    padding: ${props.theme.spacing.custom(12)} 0;
    >li{
      position: relative;
      text-align: left;
      padding: ${props.theme.spacing.custom(12)} ${props.theme.spacing.custom(24)};
      border-bottom: 1px solid #E1E7EE;
      &:last-child{
        border-bottom: none;
      }
    }
  `,
);

export const LeftActiveBar = styled.div(
  props => `
    position: absolute;
    left: 0;
    width: 6px;
    height: 40px;
    background: ${props.theme.colors.goBrandOrange.base};
    border-radius: 0 ${props.theme.misc.borderRadius.custom(
      20,
    )} ${props.theme.misc.borderRadius.custom(20)} 0;
  `,
);

export const RoomType = styled.p(
  props => `
    color: ${props.theme.colors.downriver.dark};
    font-weight: 600;
    font-size: ${props.theme.font.custom(16)};
    margin-bottom: ${props.theme.spacing.small};
    &.active{
      color: ${props.theme.colors.goBrandBlue.base};
      font-weight: 600;
    }
  `,
);

export const RoomTypePriceInfo = styled.p`
  ${textSizes.SmallW1};
  color: #777;
`;

export const RoomTypeNameWrapper = styled.div`
  display: flex;
`;

export const PackageTag = styled.div`
  height: 20px;
  width: fit-content;
  margin-bottom: 1rem;
  img {
    height: 100%;
  }
`;
